import * as S from './styles';
import ScrollAreaContainer from '@/components/molecules/ScrollAreaContainer';
import { theme } from '@/styles/theme';
import { TamanhosCartaz } from '@/components/atoms/Cartaz';
import { usePaginacaoScrollHorizontal } from '@/hooks/usePaginacaoScrollHorizontal';
import { Ref } from 'react';
import IconButton from '@/components/atoms/IconButton';
import { IconeSeta } from '@/components/atoms/Icones/IconeSeta';
import useBreakpoint from '@/hooks/useBreakpoint';
import { MembroEquipe } from '@/types/ficha';
import Elenco from '@/components/atoms/Elenco';

interface ListagemElencoProps {
  $elenco: MembroEquipe[];
  $paddingLeft?: number;
  $tamanhoCartaz?: TamanhosCartaz;
}

export default function ListagemElenco(props: ListagemElencoProps) {
  const { $elenco = [], $paddingLeft = 0, $tamanhoCartaz = 'pequeno' } = props;

  const { breakpoint } = useBreakpoint();

  const {
    viewportRef,
    scrollContainerRef,
    itemRef,
    lidarComScroll,
    paginaAtual,
    totalPaginas,
    irParaPaginaAnterior,
    irParaProximaPagina,
  } = usePaginacaoScrollHorizontal({
    gap: theme.spacing[5],
    totalItens: $elenco?.length,
  });

  return (
    <S.Container ref={viewportRef}>
      <S.ContainerScroll>
        {breakpoint !== 'mobile' &&
        paginaAtual > 1 &&
        paginaAtual <= totalPaginas ? (
          <S.ContainerButtonArrow
            $position="esquerda"
            $paddingLeft={$paddingLeft}
          >
            <IconButton
              $size={2}
              $state="default"
              $variant="solid"
              $color="accent"
              $highContrast={false}
              $loading={false}
              $Icon={IconeSeta}
              $iconProps={{ direcao: 'esquerda' }}
              $focusRing={false}
              aria-label="Botao Ver Foto Anterior"
              $onClick={irParaPaginaAnterior}
              $mostrarEstilizacaoHover={false}
              style={{
                borderRadius: '50%',
              }}
            />
          </S.ContainerButtonArrow>
        ) : null}
        <ScrollAreaContainer
          refScrollAreaViewport={scrollContainerRef}
          orientacao="horizontal"
          lidarScroll={lidarComScroll}
        >
          <S.ContainerListagemHorizontal $tamanhoCartaz={$tamanhoCartaz}>
            {$elenco?.map((elenco, index) => (
              <Elenco
                ref={index === 0 ? (itemRef as Ref<HTMLDivElement>) : null}
                key={elenco.pessoaID}
                $image={elenco?.pessoa?.fotoArquivo?.urlx2}
                $nome={elenco?.pessoa?.nome}
                $papel={elenco.personagem}
              />
            ))}
          </S.ContainerListagemHorizontal>
        </ScrollAreaContainer>
        {breakpoint !== 'mobile' && paginaAtual < totalPaginas ? (
          <S.ContainerButtonArrow
            $position="direita"
            $paddingLeft={$paddingLeft}
          >
            <IconButton
              $size={2}
              $state="default"
              $variant="solid"
              $color="accent"
              $highContrast={false}
              $loading={false}
              $Icon={IconeSeta}
              $iconProps={{ direcao: 'direita' }}
              $focusRing={false}
              aria-label="Botao Ver Foto Anterior"
              $onClick={irParaProximaPagina}
              $mostrarEstilizacaoHover={false}
              style={{
                borderRadius: '50%',
              }}
            />
          </S.ContainerButtonArrow>
        ) : null}
      </S.ContainerScroll>
    </S.Container>
  );
}
